import React from 'react';
import {Loading} from 'presentation/components/Loading/Loading';
import {Container, IconContainer} from './styles';
import {SkeletonInputProps} from './types';

export function SkeletonInput({label}: SkeletonInputProps) {
	return (
		<Container>
			{label}
			<IconContainer>
				<Loading color="inherit" size={16} />
			</IconContainer>
		</Container>
	);
}
